"use strict";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".links.page-builder").forEach((container) => {
        const button = container.querySelector(".links-more button");
        if (!button) return;

        const buttonText = button.querySelector("span") || button;
        const hiddenLinks = container.querySelectorAll('.links a[aria-hidden="true"]');
        const textMore = button.dataset.more;
        const textLess = button.dataset.less;

        button.addEventListener("click", () => {
            const isExpanded = button.getAttribute("aria-expanded") === "true";
            const willBeExpanded = !isExpanded;

            button.setAttribute("aria-expanded", willBeExpanded ? "true" : "false");
            buttonText.textContent = willBeExpanded ? textLess : textMore;

            hiddenLinks.forEach((link) => {
                if (willBeExpanded) {
                    link.style.display = "";
                    link.removeAttribute("aria-hidden");
                    link.removeAttribute("tabindex");
                } else {
                    link.style.display = "none";
                    link.setAttribute("aria-hidden", "true");
                    link.setAttribute("tabindex", "-1");
                }
            });
        });
    });
});